import { DEVELOPER_LEVEL_ACCESS } from 'src/components/access';
import { getStoreAreasForUser } from 'src/components/charts/utils/getStoreAreasForUser';
import type { IUser } from 'src/interfaces/user';

export const getOmnichannelAreaOptions = (user?: IUser | null): string[] =>
    getStoreAreasForUser(user).map((area) => area.name);

/**
 * Resolves the area filter for conversation list queries.
 * Priority: advanced areas → settings selected area → access-level default.
 * Developer with no selection → no filter (all areas).
 * Others → $in of assigned areas when none selected.
 */
export const resolveOmnichannelAreaFilter = ({
    user,
    availableAreas,
    selectedArea,
    advancedAreas = [],
}: {
    user?: IUser | null;
    availableAreas: string[];
    selectedArea: string;
    advancedAreas?: string[];
}): string | { $in: string[] } | undefined => {
    const scopedAdvancedAreas = advancedAreas.filter((area) =>
        availableAreas.includes(area)
    );

    if (scopedAdvancedAreas.length === 1) return scopedAdvancedAreas[0];
    if (scopedAdvancedAreas.length > 1) {
        return { $in: scopedAdvancedAreas };
    }

    if (selectedArea && availableAreas.includes(selectedArea)) {
        return selectedArea;
    }

    if (user?.accessLevel === DEVELOPER_LEVEL_ACCESS) return undefined;

    if (availableAreas.length === 0) return undefined;
    if (availableAreas.length === 1) return availableAreas[0];

    return { $in: availableAreas };
};

export const shouldShowOmnichannelAreaFilter = (
    availableAreas: string[]
): boolean => availableAreas.length > 1;
